<div #tableRef cdkDrag [cdkDragStartDelay]="100" [cdkDragDisabled]="!editMode || (editingTable != null && editingTable.table.tableId !== table?.tableId) || tablesMode == 'JoinedTables'" 
    (mousedown)="tableMouseDown($event)" (mouseup)="tableMouseUp($event)"
    (cdkDragStarted)="dragStarted($event)" (cdkDragMoved)="dragMoved($event)" (cdkDragEnded)="dragEnded($event)"
    [class]="'i-table ' + table?.imgType" [style]="{top: (table?.y | tableCoordinates:table?.imgType) + 'px', left: (table?.x | tableCoordinates:table?.imgType) + 'px'}"
    [class.dnd-enabled]="editMode && dndEnabled && editingTable == null">

    <!-- table info -->
    <div
        [class]="'table-info-container ' + table?.imgType + ' rotate-' + table?.rotation + ' x' + (showSurname && !editMode ? tableInfoRows.length : '1')">
        @if (showSurname && !editMode && !assignTablesReservation) {
            @for (row of tableInfoRows; track $index) {
                <span class="table-info">
                    <span [canRead]="'FullName'">{{row.customerName}}</span>
                    <span [canRead]="'Covers'">&nbsp;({{row.covers}})</span>
                </span>
            }
        } @else {
            <span class="table-info">{{table?.minCapacity}} - {{table?.maxCapacity}}</span>
        }
    </div>

    <!-- image -->
    <img #tableImageRef [src]="table?.imgType | tableImage:table:tableReservations:selected:reservationAssignTablesMode:assignTablesReservation:conflictingReservations:editMode"
        (click)="tableClicked($event)" [class]="table?.imgType + ' rotate-' + table?.rotation">

    <div [class]="'inner-container ' + table?.imgType + (editMode ? ' edit' : '') + ' rotate-' + table?.rotation">

        <!-- table name -->
        <span (click)="tableClicked($event)" class="table-name">{{table?.tableName}}</span>

        <!-- online category -->
        @if (editMode && table?.onlineCategory != null) {
            <div (click)="tableClicked($event)" class="btn-tag-group">
                <label [style.background-color]="table?.onlineCategory?.iconColor"
                    class="d-flex justify-content-center align-items-center mb-0 btn-tag-static btn-tag-static-fixed fw-bold">
                    {{table?.onlineCategory?.iconCaption}}
                </label>
            </div>
        }

        @if (editMode && (table?.excludeOnline || table?.excludeOnlineThirdParty)) {
            <div (click)="tableClicked($event)" class="exclude-channels-info-container">
                <!-- exclude from own channels category -->
                 <div class="image-wrapper">
                    @if (editMode && table?.excludeOnline) {
                        <img src="assets/images/excluded_from_own.png" class="">
                    }
                 </div>
                <!-- exclude from third party channels category -->
                <div class="image-wrapper">
                    @if (editMode && table?.excludeOnlineThirdParty) {
                        <img src="assets/images/excluded_from_tp.png">
                    }
                </div>
            </div>
        }

        <!-- time slots -->
        @if (!editMode) {
        <div (click)="tableClicked($event)" class="slots">
            <div #timeslot1 [class]="slot1.reservation | tableSlotStyle:tableReservations:conflictingReservations">
                @if (showProgress && !editMode && !reservationAssignTablesMode) {
                <div [style]="slot1.reservation | tableSlotProgress" class="progress"></div>
                }
                <span class="time">{{slot1.reservation | tableSlotTime}}</span>
            </div>
            <div #timeslot2 [class]="slot2.reservation | tableSlotStyle:tableReservations:conflictingReservations">
                @if (showProgress && !editMode && !reservationAssignTablesMode) {
                <div [style]="slot2.reservation | tableSlotProgress" class="progress"></div>
                }
                <span class="time">{{slot2.reservation  | tableSlotTime}}</span>
            </div>
            <div #timeslot3 [class]="slot3.reservation | tableSlotStyle:tableReservations:conflictingReservations">
                @if (showProgress && !editMode && !reservationAssignTablesMode) {
                <div [style]="slot3.reservation | tableSlotProgress" class="progress"></div>
                }
                <span class="time">{{slot3.reservation  | tableSlotTime}}</span>
            </div>
        </div>
        }
    </div>

</div>